import { Box, Card, CardContent, Stack, Typography } from "@mui/material";

export default function SectionCard({ title, description, icon, actions, children, sx }) {
  return (
    <Card sx={{ borderRadius: 4, ...sx }}>
      <CardContent sx={{ p: { xs: 2.2, sm: 3 } }}>
        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" gap={1.5} mb={2.5}>
          <Stack direction="row" spacing={1.4} alignItems="flex-start">
            {icon && (
              <Box sx={{ width: 42, height: 42, borderRadius: 2.5, display: "grid", placeItems: "center", bgcolor: "primary.50", color: "primary.main", background: "linear-gradient(135deg,#eff6ff,#eef2ff)" }}>
                {icon}
              </Box>
            )}
            <Box>
              <Typography variant="h6">{title}</Typography>
              {description && <Typography color="text.secondary" variant="body2" sx={{ mt: 0.45, lineHeight: 1.6 }}>{description}</Typography>}
            </Box>
          </Stack>
          {actions}
        </Stack>
        {children}
      </CardContent>
    </Card>
  );
}
